import { NavBar } from "antd-mobile";
import { useNavigate } from "react-router-dom";
import { Icon } from "../Icon";
import styles from "./index.module.scss";
export type SubHeaderProps = {
  className?: string;
  title?: string | React.ReactNode;
  onBack?: () => void;
  extra?: React.ReactNode;
};
export const SubHeader = (props: SubHeaderProps) => {
  const navigate = useNavigate();
  const onBack = () => {
    if (typeof props.onBack === "function") {
      props.onBack();
    } else {
      navigate(-1);
    }
  };
  return <NavBar right={props.extra || null} onBack={onBack} className={props.className} backArrow={<Icon name={"header-back"} size={"24px"} />} data-sentry-element="NavBar" data-sentry-component="SubHeader" data-sentry-source-file="index.tsx">
      <div className={styles.title}>{props.title}</div>
    </NavBar>;
};